import appEnv from "../../../appEnv";


export interface State {
    windowTitle: string;
}

export const initialState: State = {
    windowTitle: appEnv.siteName ?? 'Admin panel',
}